import { render, staticRenderFns } from "./batchaddnumber.vue?vue&type=template&id=276c561a&scoped=true&"
import script from "./batchaddnumber.vue?vue&type=script&lang=js&"
export * from "./batchaddnumber.vue?vue&type=script&lang=js&"
import style0 from "./batchaddnumber.vue?vue&type=style&index=0&id=276c561a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276c561a",
  null
  
)

export default component.exports